export default "/cyrillic-ext.744830a0-9c7221.woff2";